import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Download from '@/components/Download'
import Help from '@/components/Help'
import Base from '@/components/Base'
// mobile
import MainMobile from '@/components/mobile/MainMobile'
import BaseMobile from '@/components/mobile/BaseMobile'
import DownloadMobile from '@/components/mobile/DownloadMobile'
import HelpMobile from '@/components/mobile/HelpMobile'
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main
  },
  {
    path: '/base',
    name: 'Base',
    component: Base
  },
  {
    path: '/download',
    name: 'Download',
    component: Download
  },
  {
    path: '/help',
    name: 'Help',
    component: Help
  },
  {
    path: '/m',
    name: 'MainMobile',
    component: MainMobile
  },
  {
    path: '/m/base',
    name: 'BaseMobile',
    component: BaseMobile
  },
  {
    path: '/m/download',
    name: 'DownloadMobile',
    component: DownloadMobile
  },
  {
    path: '/m/help',
    name: 'HelpMobile',
    component: HelpMobile
  }
]

const router = new Router({
  routes
})

/* router.beforeEach((to, from, next) => {
  console.log('to', to.path)
  console.log('from', from.path)
  console.log('currentRoute', router.currentRoute.path)
  if (router.currentRoute.path === to.path && router.currentRoute.path !== '/') {
    // 当前路由就是即将跳转的路由，避免错误
    console.log('Avoiding navigation duplication')
    next(false) // 停止当前的导航
  } else {
    next()
  }
}) */

export default router



// WEBPACK FOOTER //
// ./src/router/index.js